import { StyleSheet } from 'aphrodite';
import { header } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	automationGroupHeader: {
		color: header,
		fontSize: 14,
		padding: '6px 16px',
		textTransform: 'uppercase',
	},
	automationRow: {
		':hover': {
			cursor: 'default',
		},
		cursor: 'default',
	},
});
